import { Skeleton } from "./Skeleton";
import { TableSkeleton } from "./TableSkeleton";

interface ListSkeletonProps {
  columns?: number;
  rows?: number;
}

/** Mirrors the standard list-page layout (header + toolbar + table) so there's no layout jump on load. */
export function ListSkeleton({ columns = 5, rows = 8 }: ListSkeletonProps) {
  return (
    <div aria-hidden="true">
      <div className="mb-6">
        <Skeleton className="h-7 w-48" />
        <Skeleton className="h-4 w-72 mt-2" />
      </div>
      <div className="bg-white rounded-xl border border-slate-200 overflow-hidden">
        <div className="p-4 border-b border-slate-100">
          <Skeleton className="h-9 w-64" />
        </div>
        <TableSkeleton columns={columns} rows={rows} />
      </div>
    </div>
  );
}